export class AgeGate {
	constructor(element) {
		this.element = element;
		this.panel = element.querySelector("[data-age-gate-panel]");
		this.yesButton = element.querySelector("[data-age-gate-yes]");
		this.noButton = element.querySelector("[data-age-gate-no]");

		this.cookieName = "zw_age_verified";
		this.rejectionUrl = "https://www.google.com";
	}

	init() {
		if (this.hasVerifiedCookie()) {
			this.element.remove();
			return;
		}

		this.yesButton?.addEventListener("click", () => {
			this.accept();
		});

		this.noButton?.addEventListener("click", () => {
			this.reject();
		});

		document.addEventListener("keydown", (event) => {
			this.handleKeydown(event);
		});

		this.open();
	}

	hasVerifiedCookie() {
		return document.cookie
			.split(";")
			.map((cookie) => cookie.trim())
			.some((cookie) =>
				cookie.startsWith(`${this.cookieName}=true`)
			);
	}

	setVerifiedCookie() {
		const secure =
			window.location.protocol === "https:" ? ";Secure" : "";

		document.cookie =
			`${this.cookieName}=true;Path=/;SameSite=Lax${secure}`;
	}

	open() {
		this.element.hidden = false;
		this.element.classList.add("is-active");
		document.documentElement.classList.add("zw-age-gate-lock");

		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				this.element.classList.add("is-open");
				this.yesButton?.focus();
			});
		});
	}

	accept() {
		this.setVerifiedCookie();
		this.close();
	}

	reject() {
		window.location.replace(this.rejectionUrl);
	}

	close() {
		this.element.classList.remove("is-open");
		this.element.classList.add("is-closing");

		const finish = () => {
			document.documentElement.classList.remove(
				"zw-age-gate-lock"
			);
			this.element.remove();
		};

		this.panel?.addEventListener(
			"transitionend",
			(event) => {
				if (
					event.target === this.panel &&
					event.propertyName === "opacity"
				) {
					finish();
				}
			},
			{ once: true }
		);

		window.setTimeout(finish, 450);
	}

	handleKeydown(event) {
		if (this.element.hidden || event.key !== "Tab") {
			return;
		}

		const buttons = [this.yesButton, this.noButton].filter(Boolean);
		const firstButton = buttons[0];
		const lastButton = buttons[buttons.length - 1];

		if (event.shiftKey && document.activeElement === firstButton) {
			event.preventDefault();
			lastButton.focus();
		}

		if (!event.shiftKey && document.activeElement === lastButton) {
			event.preventDefault();
			firstButton.focus();
		}
	}
}

export function initialiseAgeGates() {
	document.querySelectorAll("[data-age-gate]").forEach((element) => {
		const ageGate = new AgeGate(element);
		ageGate.init();
	});
}

